var _circle, _circle2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoModalVodafone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 36,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 44C67 56.7021 56.7054 67 44.0022 67C31.2987 67 21 56.7021 21 44C21 31.2979 31.2987 21 44.0022 21C56.7055 21 67 31.2979 67 44Z",
    fill: "#EE3023"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.181 56.8243C37.8632 56.8458 31.2873 51.4536 31.2579 42.7911C31.2368 37.0653 34.3302 31.551 38.2772 28.2803C42.1312 25.0942 47.4096 23.0449 52.1934 23.0278C52.8104 23.0278 53.4569 23.0786 53.8499 23.2137C49.6662 24.08 46.3362 27.976 46.3489 32.3918C46.3489 32.5396 46.3614 32.696 46.3782 32.7678C53.3807 34.475 56.5587 38.7006 56.5798 44.5445C56.5967 50.3928 51.9823 56.7991 44.181 56.8243Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoModalVodafone);
export default __webpack_public_path__ + "static/media/logoModalVodafone.853d29134990298bd2f98d3d30cc0d9b.svg";
export { ForwardRef as ReactComponent };